import WebpackBackend from '../WebpackBackend';
import { bundleNotFoundMessage, novaLocaleToFileExtension, unsupportedBundleMessage } from './util';

/**
 * Important: This class should ONLY be used when there are NO Viya services in your environment.
 *
 * Provides translations for NovaComponents-*-gui-icu bundles from npm package.
 * To use also install '@sas/github-localization-repository'.
 */
export class NovaComponentsNpmWebpackBackend extends WebpackBackend {
  bundleRegex = /^NovaComponents-(.*)-gui-icu$/;
  async import(locale, bundleName) {
    const matchResults = bundleName.match(this.bundleRegex);
    // Prefer to get en bundles from NovaWebpackBackend. Those will always be in sync with whatever the
    // components need. Getting en from @sas/github-localization-repository could result in out of date en
    // bundles if the consumer is not diligent about updating @sas/github-localization-repository.
    if (locale === 'en' || !matchResults) throw unsupportedBundleMessage(locale, bundleName);
    const [, component] = matchResults;
    const langExtension = novaLocaleToFileExtension(locale);
    let module;
    try {
      switch (component) {
        case 'AuthorizationDialog':
          module = import(`@sas/github-localization-repository/bundles/sas-institute-rnd-product/design-system-filament-nova/NovaComponents-AuthorizationDialog-gui-icu${langExtension}.properties`);
          break;
        case 'NotificationsDialog':
          module = import(`@sas/github-localization-repository/bundles/sas-institute-rnd-product/design-system-filament-nova/NovaComponents-NotificationsDialog-gui-icu${langExtension}.properties`);
          break;
        case 'DataImport':
          module = import(`@sas/github-localization-repository/bundles/sas-institute-rnd-product/design-system-filament-nova/NovaComponents-DataImport-gui-icu${langExtension}.properties`);
          break;
        case 'DataSelection':
          module = import(`@sas/github-localization-repository/bundles/sas-institute-rnd-product/design-system-filament-nova/NovaComponents-DataSelection-gui-icu${langExtension}.properties`);
          break;
        case 'PropertyPane':
          module = import(`@sas/github-localization-repository/bundles/sas-institute-rnd-product/design-system-filament-nova/NovaComponents-PropertyPane-gui-icu${langExtension}.properties`);
          break;
        case 'Tab':
          module = import(`@sas/github-localization-repository/bundles/sas-institute-rnd-product/design-system-filament-nova/NovaComponents-Tab-gui-icu${langExtension}.properties`);
          break;
        case 'VerticalBreadcrumb':
          module = import(`@sas/github-localization-repository/bundles/sas-institute-rnd-product/design-system-filament-nova/NovaComponents-VerticalBreadcrumb-gui-icu${langExtension}.properties`);
          break;
        case 'HorizontalBreadcrumb':
          module = import(`@sas/github-localization-repository/bundles/sas-institute-rnd-product/design-system-filament-nova/NovaComponents-HorizontalBreadcrumb-gui-icu${langExtension}.properties`);
          break;
        case 'AgGridWrapper':
          module = import(`@sas/github-localization-repository/bundles/sas-institute-rnd-product/design-system-filament-nova/NovaComponents-AgGridWrapper-gui-icu${langExtension}.properties`);
          break;
        default:
          module = import(`@sas/github-localization-repository/bundles/sas-institute-rnd-product/design-system-filament-nova/NovaComponents-${component}-gui-icu${langExtension}.properties`);
          break;
      }
      return (await module).default;
    } catch (e) {
      throw bundleNotFoundMessage(locale, bundleName);
    }
  }
}
//# sourceMappingURL=NovaComponentsNpmWebpackBackend.js.map